import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const CancellationRequestModal = (props: any) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        as={Modal.Dialog}
        centered
        show={props.show}
        onHide={props.close}
        backdrop="static" // Impede o fechamento ao clicar fora do modal
        keyboard={false}  // Impede o fechamento ao pressionar "Esc"
      >
        <Modal.Header>
          <Modal.Title className="h6">{t("DASHBOARD_BRANCH.CANCELLATION_REQUEST")}</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={props.close} />
        </Modal.Header>
        <Modal.Body>
          <p>{t("DASHBOARD_BRANCH.CONFIRM_CANCELLATION_DESCRIPTION")}</p>
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {props.selectedEquipments && props.selectedEquipments.length > 0 ? (
              props.selectedEquipments.map((equipment: any, index: number) => (
                <li key={index}>
                  <strong>{equipment.code_equipment}</strong> - {moment(equipment.pickup_date).format("DD/MM/YYYY")}
                </li>
              ))
            ) : (
              <p>{t("DASHBOARD_BRANCH.NO_EQUIPMENT_SELECTED")}</p>
            )}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={props.onConfirm}
            disabled={props.isLoading}
          >
            {t("CONFIRM")}
          </Button>
          <Button
            variant="secondary"
            onClick={props.close}
            disabled={props.isLoading}
          >
            {t("CANCEL")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
